import { isNil as $n, isNaN as Rn, cloneDeep as Wn, isEmpty as Dn, debounce as Pt, max as jn, isUndefined as Re, remove as Bn, toPairs as Un } from "lodash-es";
import { getCurrentInstance as W, ref as le, onMounted as We, computed as K } from "vue";
import { defineStore as Mt } from "@sunrise/pinia";
import { TCF as xt, ScreenSize as v, LocationAutocomplete as k, WeatherWarningLevels as G, WeatherServiceTypes as s } from "@sunrise/types";
import Hn from "js-cookie";
import { de as zn } from "date-fns/locale/de";
import { TZDate as Nt } from "@date-fns/tz";
import { format as kn, getTime as Gn, isWeekend as Xn, isSaturday as Fn, addDays as Ee, isSunday as Kn, getDay as Vn } from "date-fns";
import qn from "axios";
import Yn from "resize-observer-polyfill";
function de(e) {
  return !e || e.tagName === "HTML" ? 0 : e.offsetTop + de(e.offsetParent);
}
function Zn(e) {
  return e ? "nofollow noopener" : void 0;
}
function Jn(e) {
  return $n(e) || typeof e != "number" ? "" : new Intl.NumberFormat("de-DE").format(e);
}
function Qn(e) {
  if (!e || typeof e != "string")
    return -1;
  const t = e.replace(/\./g, "").replace(",", "."), n = Number(t);
  return Rn(n) ? -1 : n;
}
const ws = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getOffsetTopToDocument: de,
  getRel: Zn,
  parseThousandSeparator: Qn,
  thousandSeparator: Jn
}, Symbol.toStringTag, { value: "Module" }));
function $t(e, t) {
  if (e) {
    if (t(e))
      return e;
    if (e.children)
      for (const n of e.children) {
        const r = $t(n, t);
        if (r)
          return r;
      }
  }
}
function er(e, t) {
  if (e) {
    if (t(e))
      return e;
    if (e.children) {
      for (const n of e.children)
        if (t(n))
          return n;
    }
  }
}
function tr(e, t) {
  if (e) {
    if (t(e))
      return [e];
    if (e.children)
      return e.children.filter((n) => t(n));
  }
  return [];
}
function Rt(e, t, n = []) {
  if (e && (t(e) && n.push(e), e.children))
    for (const r of e.children)
      Rt(r, t, n);
  return n;
}
function ce(e) {
  if (!e || e.name !== "E_Link" || !e.text || e.text.length === 0)
    return null;
  const t = Wn(e.text[0]);
  return e.text[1] && (t.suffix = [e.text[1]]), t;
}
function De(e, t, n = !1) {
  return Dt(e, (r) => r.name === t, n);
}
function Wt(e, t, n = !1) {
  return Dt(e, (r) => r.label === t, n);
}
function Cs(e, t, n = !1) {
  const r = (o) => o.label === t;
  return n ? tr(e, r) : Rt(e, r, []);
}
function Dt(e, t, n = !1) {
  return n ? er(e, t) : $t(e, t);
}
function nr(e, t) {
  return !!t && !!t.properties && Object.prototype.hasOwnProperty.call(t.properties, e) && t.properties[e] !== null && t.properties[e] !== void 0;
}
function Ls(e, t, n) {
  return nr(e, t) ? t == null ? void 0 : t.properties[e] : n;
}
function _e(e) {
  let t;
  switch (e) {
    case "S_Home":
    case "S_Detail":
    case "S_Results":
      t = "S_Home";
      break;
    case "M_Resultlist_Predefined":
    case "S_Home_Rows":
    case "S_Detail_Rows":
    case "S_Results_Rows":
      t = "S_Rows";
      break;
    case "S_Home_Columns":
    case "S_Detail_Columns":
    case "S_Results_Columns":
      t = "S_Columns";
      break;
    case "S_Home_Duo":
    case "S_Detail_Duo":
    case "S_Results_Duo":
      t = "S_Duo";
      break;
    case "S_Home_Marginal":
    case "S_Detail_Marginal":
    case "S_Results_Marginal":
      t = "S_Marginal";
      break;
    case "S_Home_Marginal_Content":
    case "S_Detail_Marginal_Content":
    case "S_Results_Marginal_Content":
      t = "S_Marginal_Content";
      break;
    case "S_Home_Marginal_Side":
    case "S_Detail_Marginal_Side":
    case "S_Results_Marginal_Side":
      t = "S_Marginal_Side";
      break;
    case "Article_Paragraph":
      t = "M_Article_Paragraph";
      break;
    case "Text":
      t = "E_Text";
      break;
    default:
      t = e;
      break;
  }
  return t;
}
function As(e) {
  global.sunriseConfig = e;
}
function rr() {
  return global.sunriseConfig;
}
const je = Mt("globalState", {
  state: () => {
    var e, t;
    return {
      isOverlayOpen: !1,
      requestContext: void 0,
      ads: void 0,
      debugAds: [],
      navigationTiming: void 0,
      publicServices: {
        mlm: (t = (e = rr()) == null ? void 0 : e.mlmService) == null ? void 0 : t.url
      },
      sharedServiceData: void 0,
      urlPaths: void 0,
      debugContext: void 0,
      privacyManagerId: void 0
    };
  },
  actions: {
    addAuction(e) {
      this.$state.debugAds.push(e);
    }
  },
  getters: {
    adsEnabled: (e) => {
      var t;
      return !Dn((t = e.ads) == null ? void 0 : t.adUnits);
    }
  }
});
function jt(e) {
  return e.children ? e.children : [];
}
function or(e, t) {
  return De(t, e);
}
function ir(e, t, n) {
  return Wt(t, e, n);
}
function ar(e, t) {
  return !!De(t, e);
}
function ur(e, t, n) {
  return !!Wt(t, e, n);
}
function sr(e) {
  const t = De(e, "E_Link");
  if (!t)
    return null;
  const n = ce(t);
  return n || null;
}
function cr() {
  var e;
  return U("S_1_3", (e = W()) == null ? void 0 : e.proxy);
}
function fr() {
  var e;
  return U("S_2_3_1_3", (e = W()) == null ? void 0 : e.proxy);
}
function lr() {
  var e;
  return U("S_1_2", (e = W()) == null ? void 0 : e.proxy);
}
function dr() {
  var e;
  return U("S_Rows", (e = W()) == null ? void 0 : e.proxy);
}
function pr() {
  var e;
  return U("S_Marginal_Content", (e = W()) == null ? void 0 : e.proxy);
}
function hr() {
  var e;
  return U("S_Marginal_Side", (e = W()) == null ? void 0 : e.proxy);
}
function gr() {
  var e;
  return Bt(/^S_[_\d]+$/, (e = W()) == null ? void 0 : e.proxy);
}
function U(e, t) {
  return !t || !e ? !1 : t.$options.name === e || U(e, t.$parent);
}
function Bt(e, t) {
  return !t || !e ? !1 : e.test(t.$options.name) || Bt(e, t.$parent);
}
function _r(e) {
  return e != null && e.text ? Be(e.text) : "";
}
function Be(e) {
  return (e || []).map((n) => n.text ? n.text : Be(n.children)).join(" ");
}
function br(e) {
  var n;
  return `${(n = je().urlPaths) == null ? void 0 : n.assets}${e}`;
}
const Is = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createAssetLink: br,
  getChildByLabel: ir,
  getChildByName: or,
  getChildren: jt,
  getLinkAttributes: sr,
  hasChildByLabel: ur,
  hasChildByName: ar,
  isInMarginalContent: pr,
  isInMarginalSide: hr,
  isInRow: dr,
  isInS_1_2: lr,
  isInS_1_3: cr,
  isInS_2_3_1_3: fr,
  isInVisualIdentityModule: gr,
  renderCMSText: _r,
  renderContentTag: Be
}, Symbol.toStringTag, { value: "Module" }));
function Ut(e) {
  const t = {
    ...e.purpose.legitimateInterests,
    ...e.purpose.consents
  };
  return Object.entries(t).filter(([, n]) => n).map(([n]) => n);
}
function vr() {
  Tr(Or);
}
function be(e) {
  window.__tcfapi && window.__tcfapi("addEventListener", 2, (t, n) => {
    !n || t.eventStatus === "cmpuishown" || e(t, n);
  });
}
async function mr() {
  return new Promise((e) => {
    be(e);
  });
}
function Ue(e) {
  !window || !window.__tcfapi || window.__tcfapi("getCustomVendorConsents", 2, (t, n) => {
    e(t, n);
  });
}
function Ht(e, t) {
  return t.eventStatus !== "cmpuishown" && (t.purpose.consents[e] || t.purpose.legitimateInterests[e]);
}
function Sr(e, t) {
  yr(e, t);
}
function yr(e, t) {
  be(() => {
    Ue((n, r) => {
      if (!r) {
        t(!1);
        return;
      }
      const o = !!n.consentedVendors.find(
        (i) => i.name === e
      );
      t(o);
    });
  });
}
function Er(e) {
  return !!e.consentedVendors.find((t) => t.name === "meinestadt.de GmbH");
}
function Or(e) {
  const t = e.join(","), n = /* @__PURE__ */ new Date();
  n.setTime(n.getTime() + 60 * 24 * 60 * 60 * 1e3), Cr("cmp_ms_p", t, n, !0, !0);
}
function Tr(e) {
  window.__tcfapi && be((t) => {
    Ue((n, r) => {
      if (!r || !Er(n) || !Ht(xt.Purpose.STORAGE, t)) {
        e([]);
        return;
      }
      e(Ut(t));
    });
  });
}
const et = {
  getConsentedPurposeIds: Ut,
  initSourcepoint: vr,
  onConsentAvailable: be,
  onConsentAvailablePromise: mr,
  loadCustomVendorConsents: Ue,
  hasConsent: Ht,
  watchVendorConsent: Sr
};
async function wr() {
  const e = await et.onConsentAvailablePromise();
  return !!et.hasConsent(xt.Purpose.STORAGE, e);
}
async function Cr(e, t, n, r = !0, o = !1) {
  (await wr() || o) && Hn.set(e, t, { secure: r, expires: n, sameSite: "Strict", domain: ".meinestadt.de" });
}
function Lr(e) {
  return e && (e.label === "E_Meta_Page_H1_Tag" || e.label === "E_Meta_Page_H1_Tag_Mobile");
}
function Ps(e) {
  return new Promise((t) => {
    var o, i, u, f;
    const n = (o = e.page.page.children) == null ? void 0 : o[0];
    if (!n) {
      t(null);
      return;
    }
    const r = (i = n.children) == null ? void 0 : i[0];
    if (!r) {
      t(null);
      return;
    }
    if (Lr(r) && ((f = (u = e.page.page.children) == null ? void 0 : u[0].children) == null || f.shift()), !r || !r.text) {
      t(null);
      return;
    }
    t({ headline: r.text });
  });
}
function Ms(e) {
  let t = 0, n, r;
  if (!e || e.length === 0)
    return t.toString();
  for (n = 0; n < e.length; n++)
    r = e.charCodeAt(n), t = (t << 5) - t + r, t |= 0;
  return "id" + t;
}
const zt = 0.1;
let ee;
function kt(e) {
  let t = {};
  const n = {
    threshold: zt
  };
  let r = 0, o;
  function i(c) {
    c.forEach(function(p) {
      !p.isIntersecting && !(e != null && e.allEvents) || Object.keys(t).forEach(function(m) {
        const b = t[m];
        b.ele === p.target && (b.once && f(parseInt(m, 10)), b.cb(p));
      });
    });
  }
  function u(c, p, m = !1) {
    return typeof p != "function" || !c ? -1 : (o = _(), r++, t[r] = {
      ele: c,
      cb: p,
      once: m
    }, o.observe(c), r);
  }
  function f(c) {
    return t[c] ? (o == null || o.unobserve(t[c].ele), delete t[c], Object.keys(t).length === 0 && d(), !0) : !1;
  }
  function d() {
    o && (o.disconnect(), o = null);
  }
  function l() {
    o && (t = {}, d());
  }
  function _() {
    return o || new IntersectionObserver(i, Object.assign({}, n, e));
  }
  return { observe: u, unobserve: f, kill: l };
}
function Gt() {
  return ee || kt();
}
function Ar(e, t, n = !1) {
  return ee = Gt(), ee.observe(e, t, n);
}
function Ir(e) {
  return ee = Gt(), ee.unobserve(e);
}
const Pr = { observe: Ar, unobserve: Ir, createObserver: kt, DEFAULT_THRESHOLD: zt };
var M = /* @__PURE__ */ ((e) => (e.XS = "(min-width: 0px)", e.S = "(min-width: 375px)", e.M = "(min-width: 768px)", e.L = "(min-width: 1280px)", e.XL = "(min-width: 1440px)", e.XXL = "(min-width: 1600px)", e))(M || {});
const x = {
  [v.XS]: !1,
  [v.S]: !1,
  [v.M]: !1,
  [v.L]: !1,
  [v.XL]: !1,
  [v.XXL]: !1
}, Mr = Pt($r, 10), xr = typeof window < "u", pe = {};
let tt = 0, Xt = !1, fe;
function Nr() {
  return Object.values(M);
}
function Ft() {
  window.matchMedia && (Nr().forEach((t) => {
    const n = window.matchMedia(t);
    n.addListener((r) => nt(t, r.matches)), nt(t, n.matches);
  }), Xt = !0);
}
function nt(e, t) {
  switch (e) {
    case M.XS:
      x[v.XS] = t;
      break;
    case M.S:
      x[v.S] = t;
      break;
    case M.M:
      x[v.M] = t;
      break;
    case M.L:
      x[v.L] = t;
      break;
    case M.XL:
      x[v.XL] = t;
      break;
    case M.XXL:
      x[v.XXL] = t;
      break;
  }
  Mr();
}
function Kt() {
  const e = Object.keys(x).map((t) => parseInt(t, 10)).filter((t) => x[t]);
  return jn(e);
}
function $r() {
  const e = fe;
  fe = Kt(), Object.values(pe).forEach((t) => t(fe, e));
}
function Rr(e) {
  return xr && !Xt && Ft(), pe[++tt] = e, tt;
}
function Wr(e) {
  return pe[e] ? (delete pe[e], !0) : !1;
}
function Dr() {
  return fe || Kt();
}
const rt = {
  startListening: Ft,
  subscribe: Rr,
  unsubscribe: Wr,
  getCurrentScreenSizes: Dr
};
let $, ot = !1;
function jr(e) {
  return K(() => H() || !e.value ? Vt() : $.value >= v.XS);
}
function Br(e) {
  return K(() => H() || !e.value ? Vt() : $.value >= v.S);
}
function Ur(e) {
  return K(() => H() || !e.value ? qt() || ve() : $.value >= v.M);
}
function Hr(e) {
  return K(() => H() || !e.value ? qt() || ve() : $.value >= v.L);
}
function zr(e) {
  return K(() => H() || !e.value ? ve() : $.value >= v.XL);
}
function kr(e) {
  return K(() => H() || !e.value ? ve() : $.value >= v.XXL);
}
function Vt() {
  var t;
  const e = (t = He()) == null ? void 0 : t.mobile;
  return Re(e) ? !0 : e;
}
function qt() {
  var t;
  const e = (t = He()) == null ? void 0 : t.tablet;
  return Re(e) ? !1 : e;
}
function ve() {
  var t;
  const e = (t = He()) == null ? void 0 : t.desktop;
  return Re(e) ? !1 : e;
}
function xs() {
  const e = le(!1);
  return We(() => e.value = !0), !H() && !ot && (ot = !0, rt.subscribe((t) => {
    $.value = t;
  }), $ = le(rt.getCurrentScreenSizes())), {
    isScreenXS: jr(e),
    isScreenS: Br(e),
    isScreenM: Ur(e),
    isScreenL: Hr(e),
    isScreenXL: zr(e),
    isScreenXXL: kr(e)
  };
}
function He() {
  var e;
  return (e = je().requestContext) == null ? void 0 : e.device;
}
function H() {
  return typeof window > "u";
}
let me = !1, Gr = 0;
const te = [];
function Xr(e, t) {
  me = Kr();
  const n = ++Gr;
  return setTimeout(() => {
    te.push({
      id: n,
      ele: e,
      callback: t
    });
  }), n;
}
function Fr(e) {
  return Yr(e) ? (qr(e, te), te.length === 0 && (me = Vr()), !0) : !1;
}
function Yt(e) {
  Zt(e.target, te, e.currentTarget).forEach((n) => n.callback(e));
}
function Zt(e, t, n) {
  return e === n || t.length === 0 ? t : (t = t.filter((r) => r.ele !== e), Zt(e.parentElement, t, n));
}
function Kr() {
  return me || document.firstElementChild.addEventListener("click", Yt), !0;
}
function Vr() {
  return me && document.firstElementChild.removeEventListener("click", Yt), !1;
}
function qr(e, t) {
  return Bn(t, (n) => n.id === e);
}
function Yr(e) {
  return !!te.find((t) => t.id === e);
}
const Ns = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  subscribe: Xr,
  unsubscribe: Fr
}, Symbol.toStringTag, { value: "Module" }));
function Zr(e, t) {
  return e ? Jt(new Date(e), t) : "";
}
function Jt(e, t) {
  if (!e)
    return "";
  const n = "Europe/Berlin", r = new Nt(e, n);
  return kn(r, t, {
    locale: zn
  });
}
const $s = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatDate: Jt,
  formatDateString: Zr
}, Symbol.toStringTag, { value: "Module" })), it = ["[WILDCARD_1]", "[WILDCARD_2]", "[WILDCARD_3]", "[WILDCARD_4]"], Jr = "[LOCATION]";
function Qr(e, t) {
  const n = new URL(e), r = n.pathname !== "/" ? n.pathname.split("/") : [""];
  t.location && (r[1] = t.location);
  let o = eo(n, r);
  return t.wildcardTokens && (o = Qt(o, t.wildcardTokens)), t.placeholder && (o = to(o, t.placeholder)), o;
}
function eo(e, t) {
  let n = "";
  return e.protocol && (n += e.protocol), n += "//", e.host && (n += e.host), e.pathname && (n += t.join("/")), e.search && (n += e.search), e.hash && (n += e.hash), n;
}
function Qt(e, t) {
  let n = e;
  for (let r = 0; r < t.length && r < it.length; r++)
    n = n.replace(it[r], t[r]);
  return n;
}
function to(e, t) {
  let n = e;
  return Un(t).forEach(([r, o]) => {
    n = n.replace(r, o);
  }), n;
}
const Rs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LOCATION_PLACEHOLDER: Jr,
  mapLink: Qr,
  replaceWildcards: Qt
}, Symbol.toStringTag, { value: "Module" })), no = [
  k.LOCATION_LEVELS.LEVEL_DISTRICT,
  k.LOCATION_LEVELS.LEVEL_CITY,
  k.LOCATION_LEVELS.LEVEL_CIRCLE,
  k.LOCATION_LEVELS.LEVEL_STATE,
  k.LOCATION_LEVELS.LEVEL_NATION,
  k.LOCATION_LEVELS.LEVEL_REGION
];
function ro(e, t) {
  var i;
  const n = je(), r = io(t);
  let o = `${(i = n.urlPaths) == null ? void 0 : i.services}/citySearch?query=${e}`;
  return r.length && (o += "&" + r.map((u) => `excludeTypeLevel=${u}`).join("&")), o;
}
async function oo(e, t, n) {
  return qn.get(ro(e, t), {
    signal: n == null ? void 0 : n.signal
  }).then((r) => r.data).catch(() => []);
}
function io(e) {
  return no.filter((t) => !e.includes(t));
}
const Ws = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getLocations: oo
}, Symbol.toStringTag, { value: "Module" }));
function ao(e, t) {
  return new Promise((n, r) => {
    var u;
    t = t || {}, t.execute = t && t.execute ? t.execute : "defer";
    const o = document.createElement("script"), i = document.getElementsByTagName("script")[0];
    o.setAttribute(t.execute, "true"), o.src = e, o.onload = n, o.onerror = r, (u = i.parentNode) == null || u.insertBefore(o, i);
  });
}
const uo = { load: ao };
function so(e) {
  We(() => {
    uo.load(`https:////www.google.com/recaptcha/api.js?render=${e}`);
  });
}
function co(e) {
  return window.grecaptcha ? new Promise((t, n) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(e, { action: "submit" }).then((r) => {
        t(r);
      }).catch(() => {
        n();
      });
    });
  }) : Promise.reject();
}
const Ds = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  initRecaptcha: so,
  recaptchaChecked: co
}, Symbol.toStringTag, { value: "Module" })), j = {};
let Oe = 0, T;
function fo(e) {
  e.forEach(function(t) {
    Object.keys(j).forEach(function(n) {
      const r = j[n];
      r.ele === t.target && (r.once && he(parseInt(n, 10)), r.cb(t));
    });
  });
}
function Ae(e, t, n) {
  return typeof t != "function" || !e ? -1 : (T = po(), Oe++, j[Oe] = {
    ele: e,
    cb: t,
    once: n
  }, T.observe(e), Oe);
}
function he(e) {
  return j[e] ? (T == null || T.unobserve(j[e].ele), delete j[e], Object.keys(j).length === 0 && lo(), !0) : !1;
}
function lo() {
  T && (T.disconnect(), T = null);
}
function po() {
  return T || new Yn(fo);
}
const js = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  observe: Ae,
  unobserve: he
}, Symbol.toStringTag, { value: "Module" }));
function ho(e = 0) {
  return e == null ? "0px" : e + "px";
}
function go(e) {
  if (!e || typeof e != "string")
    return 0;
  const t = e.replace(/[^\d]/g, "");
  return t ? Number(t) : NaN;
}
const Bs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  asPx: ho,
  extractNumberFromString: go
}, Symbol.toStringTag, { value: "Module" })), en = "S_Meta_Data", tn = "S_Sticky_Content", ze = "E_Text", nn = "S_Stage";
function V(e) {
  if (!e.name)
    return e.label;
  let t;
  switch (e.name.toLocaleLowerCase()) {
    case "text":
      t = e.label;
      break;
    default:
      t = e.name;
      break;
  }
  return t;
}
function rn(e) {
  return V(e) === en;
}
function on(e) {
  return _e(V(e)) === ze;
}
function an(e) {
  return _e(V(e)) === nn;
}
function un(e) {
  return _e(V(e)) === tn;
}
const _o = "Headline", bo = "PrimaryButton", vo = "SecondaryButton", mo = "MoreLink";
function So(e) {
  const t = ({ label: c }) => c === _o, n = ({ label: c }) => c === bo, r = ({ label: c }) => c === vo, o = ({ label: c }) => c === mo;
  let i = null, u = null, f = null, d = null;
  const l = [], _ = jt(e);
  if (!(!_ || !_.length)) {
    for (const c of _) {
      if (t(c)) {
        i = c;
        continue;
      }
      if (n(c)) {
        u = ce(c);
        continue;
      }
      if (r(c)) {
        f = ce(c);
        continue;
      }
      if (o(c)) {
        d = ce(c);
        continue;
      }
      l.push(c);
    }
    return { headline: i, primaryButton: u, moreLink: d, secondaryButton: f, children: l };
  }
}
const Us = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  E_TEXT_COMPONENT: ze,
  S_META_DATA_COMPONENT: en,
  S_STAGE: nn,
  S_STICKY_CONTENT_COMPONENT: tn,
  getCorrectName: V,
  isMetaDataComponent: rn,
  isStageComponent: an,
  isStickyContent: un,
  isTextComponent: on,
  prepareContent: So
}, Symbol.toStringTag, { value: "Module" }));
function yo(e) {
  switch (e) {
    case s.WeatherCondition.SONNIG:
    case s.WeatherCondition.HEITER:
      return s.WeatherIcons.TSonnig;
    case s.WeatherCondition.KLAR:
      return s.WeatherIcons.TKlar;
    case s.WeatherCondition.BEDECKT:
      return s.WeatherIcons.TBedeckt;
    case s.WeatherCondition.WOLKIG:
    case s.WeatherCondition.IN_WOLKEN:
    case s.WeatherCondition.LEICHT_BEWOELKT:
      return s.WeatherIcons.TWolkig;
    case s.WeatherCondition.STARK_BEWOELKT:
      return s.WeatherIcons.TBewoelkt;
    case s.WeatherCondition.REGENSCHAUER:
    case s.WeatherCondition.REGEN:
      return s.WeatherIcons.TRegen;
    case s.WeatherCondition.SCHNEEFALL:
    case s.WeatherCondition.SCHNEEREGEN:
    case s.WeatherCondition.SCHNEESCHAUER:
      return s.WeatherIcons.TSchnee;
    case s.WeatherCondition.NEBEL:
      return s.WeatherIcons.TNebel;
    case s.WeatherCondition.SPRUEHREGEN:
      return s.WeatherIcons.TSpruehregen;
    case s.WeatherCondition.GEWITTER:
    default:
      return s.WeatherIcons.TGewitter;
  }
}
function Eo(e) {
  switch (e) {
    case s.WeatherCondition.SONNIG:
    case s.WeatherCondition.HEITER:
      return s.WeatherIcons.NSonnig;
    case s.WeatherCondition.KLAR:
      return s.WeatherIcons.NKlar;
    case s.WeatherCondition.BEDECKT:
      return s.WeatherIcons.NBedeckt;
    case s.WeatherCondition.WOLKIG:
    case s.WeatherCondition.IN_WOLKEN:
    case s.WeatherCondition.LEICHT_BEWOELKT:
      return s.WeatherIcons.NWolkig;
    case s.WeatherCondition.STARK_BEWOELKT:
      return s.WeatherIcons.NBewoelkt;
    case s.WeatherCondition.REGENSCHAUER:
    case s.WeatherCondition.REGEN:
      return s.WeatherIcons.NRegen;
    case s.WeatherCondition.SCHNEEFALL:
    case s.WeatherCondition.SCHNEEREGEN:
    case s.WeatherCondition.SCHNEESCHAUER:
      return s.WeatherIcons.NSchnee;
    case s.WeatherCondition.NEBEL:
      return s.WeatherIcons.NNebel;
    case s.WeatherCondition.SPRUEHREGEN:
      return s.WeatherIcons.NSpruehregen;
    case s.WeatherCondition.GEWITTER:
    default:
      return s.WeatherIcons.NGewitter;
  }
}
function Oo(e) {
  const t = new Date(Date.now()).toISOString(), n = at(t);
  let r = e.hourlyWeatherData[0], o = !1;
  for (let i = e.hourlyWeatherData.length - 1; i >= 0 && !o; i--) {
    const u = e.hourlyWeatherData[i];
    at(u.time) < n && (r = u, o = !0);
  }
  return r;
}
function at(e) {
  const t = "Europe/Berlin", n = new Nt(e, t);
  return Gn(n);
}
function To(e) {
  return sn(e.time, e.weatherCondition);
}
function sn(e, t) {
  const r = new Date(e).getHours(), o = 18 <= r || r <= 5;
  return cn(t, o);
}
function cn(e, t) {
  return t ? Eo(e) : yo(e);
}
const fn = {
  [G.NONE]: {
    text: "Keine amtliche Warnung aktiv",
    subtext: "Es werden keine wetterbedingten Gefährdungen in {{location}} erwartet.",
    bgColor: "bg-color-alert-positive-25",
    color: "text-color-alert-positive-100"
  },
  [G.LEVEL_0]: {
    text: "Wetterhinweis",
    subtext: "Wetterhinweis für {{location}}",
    bgColor: "bg-color-rating-lightblue-25",
    color: "text-color-rating-lightblue-100"
  },
  [G.LEVEL_1]: {
    text: "Stufe 1: Amtliche Warnung",
    subtext: "Unwetterwarnung für {{location}}",
    bgColor: "bg-color-rating-lightorange-25",
    color: "text-color-rating-lightorange-100"
  },
  [G.LEVEL_2]: {
    text: "Stufe 2: Amtliche Warnung vor markantem Wetter",
    subtext: "Unwetterwarnung für {{location}}",
    bgColor: "bg-color-rating-mediumorange-25",
    color: "text-color-rating-mediumorange-100"
  },
  [G.LEVEL_3]: {
    text: "Stufe 3: Amtliche Unwetterwarnung",
    subtext: "Unwetterwarnung für {{location}}",
    bgColor: "bg-color-rating-lightred-25",
    color: "text-color-rating-lightred-100"
  },
  [G.LEVEL_4]: {
    text: "Stufe 4: Amtliche Warnung vor extremen Unwetter",
    subtext: "Unwetterwarnung für {{location}}",
    bgColor: "bg-color-rating-mediumred-25",
    color: "text-color-rating-mediumred-100"
  }
};
function wo(e, t) {
  const n = fn[e];
  return {
    ...n,
    subtext: n.subtext.replace("{{location}}", t)
  };
}
function ln(e) {
  return {
    text: e.text,
    fromISOString: e.start,
    toISOString: e.end
  };
}
function Co(e) {
  return e.reduce((t, n) => {
    const r = n.warningLevel;
    return t[r] || (t[r] = []), t[r].push(ln(n)), t;
  }, {});
}
function Lo(e) {
  return e ? Object.keys(e).sort().reverse().map((t) => parseInt(t, 10)) : [];
}
const Hs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  WARNING_LEVELS: fn,
  findCurrentWeather: Oo,
  getIconName: To,
  getIconNameBy: cn,
  getIconNameFor: sn,
  getOrderedWarnings: Lo,
  getWarningLevel: wo,
  mapWarning: ln,
  orderWarnings: Co
}, Symbol.toStringTag, { value: "Module" }));
function Ao() {
  const e = /* @__PURE__ */ new Date();
  if (Xn(e)) {
    if (Fn(e))
      return Ee(e, 1);
    if (Kn(e))
      return Ee(e, 6);
  }
  const n = 6 - Vn(e);
  return Ee(e, n);
}
const zs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getDateOfNextSaturdayOrSunday: Ao
}, Symbol.toStringTag, { value: "Module" }));
let Ie;
function ks(e) {
  Ie = e;
}
function Io(e) {
  if (!(rn(e) || an(e) || un(e)))
    return Po(e);
}
function Gs(e) {
  return !e || !e.children ? [] : e.children.map((t) => ({
    name: Io(t),
    content: t
  })).filter((t) => !!t.name);
}
function Po(e) {
  if (on(e))
    return ze;
  const t = _e(V(e));
  if (Mo(t))
    return t;
  const n = xo(t, Ie) || "";
  return Ie[n] ? t : "MsMissingElement";
}
function Mo(e) {
  var n;
  const t = (n = W()) == null ? void 0 : n.components;
  return !!(t != null && t[e]);
}
function xo(e, t) {
  return Object.keys(t).find((n) => n.indexOf(e + ".vue") >= 0);
}
function Xs() {
  const e = le(!1);
  return We(() => e.value = !0), e;
}
const X = {};
let Te = 0, ne = !1;
const No = 150, dn = Pt((e) => {
  Object.keys(X).forEach(function(t) {
    const n = X[t];
    n.once && pn(parseInt(t, 10)), n.cb(e);
  });
}, No);
function $o(e, t = !1) {
  return typeof e != "function" ? -1 : (Te++, X[Te] = {
    cb: e,
    once: t
  }, Do(), Te);
}
function pn(e) {
  return X[e] ? (delete X[e], Object.keys(X).length === 0 && Ro(), !0) : !1;
}
function Ro() {
  ne && Wo();
}
function Wo() {
  ne && (window.removeEventListener("resize", dn), ne = !1);
}
function Do() {
  ne || (window.addEventListener("resize", dn), ne = !0);
}
let re;
function hn(e) {
  let t = {}, n, r = 0, o, i;
  function u(a) {
    return typeof a != "function";
  }
  function f(a, g, Qe) {
    if (u(g) || u(Qe) || !a)
      return -1;
    n = c();
    const Nn = n.observe(a, () => g(a)), ue = {
      target: a,
      onEnter: g,
      onLeave: Qe,
      resizeObserverId: Ae(a, () => w(ue)),
      targetObserverId: Nn
    };
    return S(ue), w(ue), p(), m(), t[++r] = ue, r;
  }
  function d(a) {
    return t[a] ? (n == null || n.unobserve(t[a].targetObserverId), y(t[a].lowerBoundObserverId, t[a].lowerMarker), y(t[a].upperBoundObserverId, t[a].upperMarker), he(t[a].resizeObserverId), delete t[a], Object.keys(t).length === 0 && l(), !0) : !1;
  }
  function l() {
    n && (b(), o && he(o), n.kill(), o = null, n = null);
  }
  function _() {
    n && (t = {}, l());
  }
  function c() {
    return n || Pr.createObserver(e);
  }
  function p() {
    o || (o = Ae(document.body, () => {
      Object.values(t).forEach((a) => {
        S(a), w(a);
      });
    }));
  }
  function m() {
    i || (i = $o(() => {
      E();
    }));
  }
  function b() {
    i && (pn(i), i = null);
  }
  function S(a) {
    !a.lowerMarker && !Z(a.target) && (a.lowerMarker = Je(a.target), a.lowerBoundObserverId = n == null ? void 0 : n.observe(a.lowerMarker, () => {
      a.onLeave(
        a.target,
        "DOWN"
        /* DOWN */
      );
    })), !a.upperMarker && !O(a.target) && (a.upperMarker = Je(a.target), a.upperBoundObserverId = n == null ? void 0 : n.observe(a.upperMarker, () => {
      a.onLeave(
        a.target,
        "UP"
        /* UP */
      );
    }));
  }
  function E() {
    Object.values(t).forEach((a) => {
      S(a), w(a);
    });
  }
  function y(a, g) {
    g && g.remove(), a && (n == null || n.unobserve(a));
  }
  function O(a) {
    return de(a) < window.innerHeight + a.getBoundingClientRect().height / 2;
  }
  function Z(a) {
    return de(a) + a.getBoundingClientRect().height / 2 + window.innerHeight > document.body.getBoundingClientRect().height;
  }
  function w(a) {
    const g = a.target.getBoundingClientRect();
    O(a.target) ? y(a.upperBoundObserverId, a.upperMarker) : a.upperMarker && xn(a.upperMarker, g.height), Z(a.target) ? y(a.lowerBoundObserverId, a.lowerMarker) : a.lowerMarker && Mn(a.lowerMarker, g.height);
  }
  function D(a) {
    let g = 0.1;
    return typeof (e == null ? void 0 : e.threshold) == "number" && (g = e.threshold), Math.trunc(a * (1 - g) + 1);
  }
  function Mn(a, g) {
    a && (a.style.top = `calc(100vh + ${D(g)}px)`);
  }
  function xn(a, g) {
    a && (a.style.top = `calc(-100vh - ${D(g)}px)`);
  }
  function Je(a) {
    window.getComputedStyle(a).position || (a.style.position = "relative");
    const g = document.createElement("div");
    return g.style.position = "absolute", g.style.zIndex = "-1", a.appendChild(g), g;
  }
  return { observe: f, unobserve: d, kill: _ };
}
function gn() {
  return re || hn();
}
function jo(e, t, n) {
  return re = gn(), re.observe(e, t, n);
}
function Bo(e) {
  return re = gn(), re.unobserve(e);
}
const Fs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  create: hn,
  observe: jo,
  unobserve: Bo
}, Symbol.toStringTag, { value: "Module" }));
function Uo() {
  var e, t;
  (t = (e = document == null ? void 0 : document.body) == null ? void 0 : e.parentElement) == null || t.classList.add("-noScroll");
}
function Ho() {
  var e, t;
  (t = (e = document == null ? void 0 : document.body) == null ? void 0 : e.parentElement) == null || t.classList.remove("-noScroll");
}
const Ks = { disablePageScroll: Uo, enablePageScroll: Ho };
function zo(e) {
  if (!e)
    return;
  const t = document.createElement("a");
  t.href = e, t.target = "_blank", t.click();
}
function _n(e, t, n) {
  if (!e)
    return null;
  const r = ko(e);
  let o = `${r.protocol}//${r.host}${r.pathname}`;
  if (t) {
    const i = st(r.search || "");
    o += ut({
      ...i,
      ...t
    });
  }
  if (n) {
    const i = st(r.hash || "");
    o += ut(
      {
        ...i,
        ...n
      },
      !0
    );
  }
  return o;
}
function ut(e, t) {
  let n = t ? "#" : "?";
  return !e || Object.keys(e).length === 0 ? "" : (Object.keys(e).forEach(function(r) {
    n.length === 1 ? n += r + "=" + encodeURIComponent(e[r]) : n += "&" + r + "=" + encodeURIComponent(e[r]);
  }), n);
}
function st(e) {
  return !e || e.length === 1 ? {} : e.substr(1).split("&").reduce((n, r) => {
    const o = r.split("=");
    return o.length === 2 && (n[o[0]] = decodeURIComponent(o[1])), n;
  }, {});
}
function ko(e) {
  const t = document.createElement("a");
  return t.href = e, {
    protocol: t.protocol,
    host: t.host,
    hostname: t.hostname,
    port: t.port,
    pathname: Go(t.pathname),
    search: t.search,
    hash: t.hash
  };
}
function Go(e) {
  return !e || e.length === 0 ? "" : e[0] !== "/" ? `/${e}` : e;
}
function Xo(e, t, n) {
  const r = _n(e, t, n);
  if (!r)
    return !1;
  window.location.href = r;
}
function Fo(e) {
  return e.toString().replace(/\?.*/, "").replace(/\/$/, "");
}
function Ko(e) {
  return Object.entries(e).flatMap(([t, n]) => Array.isArray(n) ? n.map((r) => [t, r]) : [[t, n]]).filter((t) => t[1] !== void 0 && t[1] !== "").map(([t, n]) => `${t}=${n}`).join("&");
}
const Vs = { openNewTabXDomain: zo, redirect: Xo, withoutQueryString: Fo, parameterSerializer: Ko, buildUrl: _n }, Vo = "3.29.3", qs = Mt("deploymentInfo", {
  state: () => ({
    sunriseVersion: Vo
  })
});
function qo() {
  this.__data__ = [], this.size = 0;
}
function bn(e, t) {
  return e === t || e !== e && t !== t;
}
function Se(e, t) {
  for (var n = e.length; n--; )
    if (bn(e[n][0], t))
      return n;
  return -1;
}
var Yo = Array.prototype, Zo = Yo.splice;
function Jo(e) {
  var t = this.__data__, n = Se(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : Zo.call(t, n, 1), --this.size, !0;
}
function Qo(e) {
  var t = this.__data__, n = Se(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function ei(e) {
  return Se(this.__data__, e) > -1;
}
function ti(e, t) {
  var n = this.__data__, r = Se(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
function A(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
A.prototype.clear = qo;
A.prototype.delete = Jo;
A.prototype.get = Qo;
A.prototype.has = ei;
A.prototype.set = ti;
function ni() {
  this.__data__ = new A(), this.size = 0;
}
function ri(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function oi(e) {
  return this.__data__.get(e);
}
function ii(e) {
  return this.__data__.has(e);
}
var vn = typeof global == "object" && global && global.Object === Object && global, ai = typeof self == "object" && self && self.Object === Object && self, I = vn || ai || Function("return this")(), R = I.Symbol, mn = Object.prototype, ui = mn.hasOwnProperty, si = mn.toString, J = R ? R.toStringTag : void 0;
function ci(e) {
  var t = ui.call(e, J), n = e[J];
  try {
    e[J] = void 0;
    var r = !0;
  } catch {
  }
  var o = si.call(e);
  return r && (t ? e[J] = n : delete e[J]), o;
}
var fi = Object.prototype, li = fi.toString;
function di(e) {
  return li.call(e);
}
var pi = "[object Null]", hi = "[object Undefined]", ct = R ? R.toStringTag : void 0;
function q(e) {
  return e == null ? e === void 0 ? hi : pi : ct && ct in Object(e) ? ci(e) : di(e);
}
function ke(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var gi = "[object AsyncFunction]", _i = "[object Function]", bi = "[object GeneratorFunction]", vi = "[object Proxy]";
function Sn(e) {
  if (!ke(e))
    return !1;
  var t = q(e);
  return t == _i || t == bi || t == gi || t == vi;
}
var we = I["__core-js_shared__"], ft = function() {
  var e = /[^.]+$/.exec(we && we.keys && we.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function mi(e) {
  return !!ft && ft in e;
}
var Si = Function.prototype, yi = Si.toString;
function z(e) {
  if (e != null) {
    try {
      return yi.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Ei = /[\\^$.*+?()[\]{}|]/g, Oi = /^\[object .+?Constructor\]$/, Ti = Function.prototype, wi = Object.prototype, Ci = Ti.toString, Li = wi.hasOwnProperty, Ai = RegExp(
  "^" + Ci.call(Li).replace(Ei, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Ii(e) {
  if (!ke(e) || mi(e))
    return !1;
  var t = Sn(e) ? Ai : Oi;
  return t.test(z(e));
}
function Pi(e, t) {
  return e == null ? void 0 : e[t];
}
function Y(e, t) {
  var n = Pi(e, t);
  return Ii(n) ? n : void 0;
}
var oe = Y(I, "Map"), ie = Y(Object, "create");
function Mi() {
  this.__data__ = ie ? ie(null) : {}, this.size = 0;
}
function xi(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Ni = "__lodash_hash_undefined__", $i = Object.prototype, Ri = $i.hasOwnProperty;
function Wi(e) {
  var t = this.__data__;
  if (ie) {
    var n = t[e];
    return n === Ni ? void 0 : n;
  }
  return Ri.call(t, e) ? t[e] : void 0;
}
var Di = Object.prototype, ji = Di.hasOwnProperty;
function Bi(e) {
  var t = this.__data__;
  return ie ? t[e] !== void 0 : ji.call(t, e);
}
var Ui = "__lodash_hash_undefined__";
function Hi(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = ie && t === void 0 ? Ui : t, this;
}
function B(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
B.prototype.clear = Mi;
B.prototype.delete = xi;
B.prototype.get = Wi;
B.prototype.has = Bi;
B.prototype.set = Hi;
function zi() {
  this.size = 0, this.__data__ = {
    hash: new B(),
    map: new (oe || A)(),
    string: new B()
  };
}
function ki(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function ye(e, t) {
  var n = e.__data__;
  return ki(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function Gi(e) {
  var t = ye(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function Xi(e) {
  return ye(this, e).get(e);
}
function Fi(e) {
  return ye(this, e).has(e);
}
function Ki(e, t) {
  var n = ye(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
function P(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
P.prototype.clear = zi;
P.prototype.delete = Gi;
P.prototype.get = Xi;
P.prototype.has = Fi;
P.prototype.set = Ki;
var Vi = 200;
function qi(e, t) {
  var n = this.__data__;
  if (n instanceof A) {
    var r = n.__data__;
    if (!oe || r.length < Vi - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new P(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
function C(e) {
  var t = this.__data__ = new A(e);
  this.size = t.size;
}
C.prototype.clear = ni;
C.prototype.delete = ri;
C.prototype.get = oi;
C.prototype.has = ii;
C.prototype.set = qi;
var Yi = "__lodash_hash_undefined__";
function Zi(e) {
  return this.__data__.set(e, Yi), this;
}
function Ji(e) {
  return this.__data__.has(e);
}
function ge(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new P(); ++t < n; )
    this.add(e[t]);
}
ge.prototype.add = ge.prototype.push = Zi;
ge.prototype.has = Ji;
function Qi(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
function ea(e, t) {
  return e.has(t);
}
var ta = 1, na = 2;
function yn(e, t, n, r, o, i) {
  var u = n & ta, f = e.length, d = t.length;
  if (f != d && !(u && d > f))
    return !1;
  var l = i.get(e), _ = i.get(t);
  if (l && _)
    return l == t && _ == e;
  var c = -1, p = !0, m = n & na ? new ge() : void 0;
  for (i.set(e, t), i.set(t, e); ++c < f; ) {
    var b = e[c], S = t[c];
    if (r)
      var E = u ? r(S, b, c, t, e, i) : r(b, S, c, e, t, i);
    if (E !== void 0) {
      if (E)
        continue;
      p = !1;
      break;
    }
    if (m) {
      if (!Qi(t, function(y, O) {
        if (!ea(m, O) && (b === y || o(b, y, n, r, i)))
          return m.push(O);
      })) {
        p = !1;
        break;
      }
    } else if (!(b === S || o(b, S, n, r, i))) {
      p = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), p;
}
var lt = I.Uint8Array;
function ra(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, o) {
    n[++t] = [o, r];
  }), n;
}
function oa(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var ia = 1, aa = 2, ua = "[object Boolean]", sa = "[object Date]", ca = "[object Error]", fa = "[object Map]", la = "[object Number]", da = "[object RegExp]", pa = "[object Set]", ha = "[object String]", ga = "[object Symbol]", _a = "[object ArrayBuffer]", ba = "[object DataView]", dt = R ? R.prototype : void 0, Ce = dt ? dt.valueOf : void 0;
function va(e, t, n, r, o, i, u) {
  switch (n) {
    case ba:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case _a:
      return !(e.byteLength != t.byteLength || !i(new lt(e), new lt(t)));
    case ua:
    case sa:
    case la:
      return bn(+e, +t);
    case ca:
      return e.name == t.name && e.message == t.message;
    case da:
    case ha:
      return e == t + "";
    case fa:
      var f = ra;
    case pa:
      var d = r & ia;
      if (f || (f = oa), e.size != t.size && !d)
        return !1;
      var l = u.get(e);
      if (l)
        return l == t;
      r |= aa, u.set(e, t);
      var _ = yn(f(e), f(t), r, o, i, u);
      return u.delete(e), _;
    case ga:
      if (Ce)
        return Ce.call(e) == Ce.call(t);
  }
  return !1;
}
function ma(e, t) {
  for (var n = -1, r = t.length, o = e.length; ++n < r; )
    e[o + n] = t[n];
  return e;
}
var L = Array.isArray;
function Sa(e, t, n) {
  var r = t(e);
  return L(e) ? r : ma(r, n(e));
}
function ya(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, o = 0, i = []; ++n < r; ) {
    var u = e[n];
    t(u, n, e) && (i[o++] = u);
  }
  return i;
}
function Ea() {
  return [];
}
var Oa = Object.prototype, Ta = Oa.propertyIsEnumerable, pt = Object.getOwnPropertySymbols, wa = pt ? function(e) {
  return e == null ? [] : (e = Object(e), ya(pt(e), function(t) {
    return Ta.call(e, t);
  }));
} : Ea;
function Ca(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
function F(e) {
  return e != null && typeof e == "object";
}
var La = "[object Arguments]";
function ht(e) {
  return F(e) && q(e) == La;
}
var En = Object.prototype, Aa = En.hasOwnProperty, Ia = En.propertyIsEnumerable, On = ht(/* @__PURE__ */ function() {
  return arguments;
}()) ? ht : function(e) {
  return F(e) && Aa.call(e, "callee") && !Ia.call(e, "callee");
};
function Pa() {
  return !1;
}
var Tn = typeof exports == "object" && exports && !exports.nodeType && exports, gt = Tn && typeof module == "object" && module && !module.nodeType && module, Ma = gt && gt.exports === Tn, _t = Ma ? I.Buffer : void 0, xa = _t ? _t.isBuffer : void 0, Pe = xa || Pa, Na = 9007199254740991, $a = /^(?:0|[1-9]\d*)$/;
function Ge(e, t) {
  var n = typeof e;
  return t = t ?? Na, !!t && (n == "number" || n != "symbol" && $a.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Ra = 9007199254740991;
function Xe(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Ra;
}
var Wa = "[object Arguments]", Da = "[object Array]", ja = "[object Boolean]", Ba = "[object Date]", Ua = "[object Error]", Ha = "[object Function]", za = "[object Map]", ka = "[object Number]", Ga = "[object Object]", Xa = "[object RegExp]", Fa = "[object Set]", Ka = "[object String]", Va = "[object WeakMap]", qa = "[object ArrayBuffer]", Ya = "[object DataView]", Za = "[object Float32Array]", Ja = "[object Float64Array]", Qa = "[object Int8Array]", eu = "[object Int16Array]", tu = "[object Int32Array]", nu = "[object Uint8Array]", ru = "[object Uint8ClampedArray]", ou = "[object Uint16Array]", iu = "[object Uint32Array]", h = {};
h[Za] = h[Ja] = h[Qa] = h[eu] = h[tu] = h[nu] = h[ru] = h[ou] = h[iu] = !0;
h[Wa] = h[Da] = h[qa] = h[ja] = h[Ya] = h[Ba] = h[Ua] = h[Ha] = h[za] = h[ka] = h[Ga] = h[Xa] = h[Fa] = h[Ka] = h[Va] = !1;
function au(e) {
  return F(e) && Xe(e.length) && !!h[q(e)];
}
function uu(e) {
  return function(t) {
    return e(t);
  };
}
var wn = typeof exports == "object" && exports && !exports.nodeType && exports, Q = wn && typeof module == "object" && module && !module.nodeType && module, su = Q && Q.exports === wn, Le = su && vn.process, bt = function() {
  try {
    var e = Q && Q.require && Q.require("util").types;
    return e || Le && Le.binding && Le.binding("util");
  } catch {
  }
}(), vt = bt && bt.isTypedArray, Cn = vt ? uu(vt) : au, cu = Object.prototype, fu = cu.hasOwnProperty;
function lu(e, t) {
  var n = L(e), r = !n && On(e), o = !n && !r && Pe(e), i = !n && !r && !o && Cn(e), u = n || r || o || i, f = u ? Ca(e.length, String) : [], d = f.length;
  for (var l in e)
    fu.call(e, l) && !(u && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    Ge(l, d))) && f.push(l);
  return f;
}
var du = Object.prototype;
function pu(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || du;
  return e === n;
}
function hu(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var gu = hu(Object.keys, Object), _u = Object.prototype, bu = _u.hasOwnProperty;
function vu(e) {
  if (!pu(e))
    return gu(e);
  var t = [];
  for (var n in Object(e))
    bu.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function mu(e) {
  return e != null && Xe(e.length) && !Sn(e);
}
function Ln(e) {
  return mu(e) ? lu(e) : vu(e);
}
function mt(e) {
  return Sa(e, Ln, wa);
}
var Su = 1, yu = Object.prototype, Eu = yu.hasOwnProperty;
function Ou(e, t, n, r, o, i) {
  var u = n & Su, f = mt(e), d = f.length, l = mt(t), _ = l.length;
  if (d != _ && !u)
    return !1;
  for (var c = d; c--; ) {
    var p = f[c];
    if (!(u ? p in t : Eu.call(t, p)))
      return !1;
  }
  var m = i.get(e), b = i.get(t);
  if (m && b)
    return m == t && b == e;
  var S = !0;
  i.set(e, t), i.set(t, e);
  for (var E = u; ++c < d; ) {
    p = f[c];
    var y = e[p], O = t[p];
    if (r)
      var Z = u ? r(O, y, p, t, e, i) : r(y, O, p, e, t, i);
    if (!(Z === void 0 ? y === O || o(y, O, n, r, i) : Z)) {
      S = !1;
      break;
    }
    E || (E = p == "constructor");
  }
  if (S && !E) {
    var w = e.constructor, D = t.constructor;
    w != D && "constructor" in e && "constructor" in t && !(typeof w == "function" && w instanceof w && typeof D == "function" && D instanceof D) && (S = !1);
  }
  return i.delete(e), i.delete(t), S;
}
var Me = Y(I, "DataView"), xe = Y(I, "Promise"), Ne = Y(I, "Set"), $e = Y(I, "WeakMap"), St = "[object Map]", Tu = "[object Object]", yt = "[object Promise]", Et = "[object Set]", Ot = "[object WeakMap]", Tt = "[object DataView]", wu = z(Me), Cu = z(oe), Lu = z(xe), Au = z(Ne), Iu = z($e), N = q;
(Me && N(new Me(new ArrayBuffer(1))) != Tt || oe && N(new oe()) != St || xe && N(xe.resolve()) != yt || Ne && N(new Ne()) != Et || $e && N(new $e()) != Ot) && (N = function(e) {
  var t = q(e), n = t == Tu ? e.constructor : void 0, r = n ? z(n) : "";
  if (r)
    switch (r) {
      case wu:
        return Tt;
      case Cu:
        return St;
      case Lu:
        return yt;
      case Au:
        return Et;
      case Iu:
        return Ot;
    }
  return t;
});
var Pu = 1, wt = "[object Arguments]", Ct = "[object Array]", se = "[object Object]", Mu = Object.prototype, Lt = Mu.hasOwnProperty;
function xu(e, t, n, r, o, i) {
  var u = L(e), f = L(t), d = u ? Ct : N(e), l = f ? Ct : N(t);
  d = d == wt ? se : d, l = l == wt ? se : l;
  var _ = d == se, c = l == se, p = d == l;
  if (p && Pe(e)) {
    if (!Pe(t))
      return !1;
    u = !0, _ = !1;
  }
  if (p && !_)
    return i || (i = new C()), u || Cn(e) ? yn(e, t, n, r, o, i) : va(e, t, d, n, r, o, i);
  if (!(n & Pu)) {
    var m = _ && Lt.call(e, "__wrapped__"), b = c && Lt.call(t, "__wrapped__");
    if (m || b) {
      var S = m ? e.value() : e, E = b ? t.value() : t;
      return i || (i = new C()), o(S, E, n, r, i);
    }
  }
  return p ? (i || (i = new C()), Ou(e, t, n, r, o, i)) : !1;
}
function Fe(e, t, n, r, o) {
  return e === t ? !0 : e == null || t == null || !F(e) && !F(t) ? e !== e && t !== t : xu(e, t, n, r, Fe, o);
}
var Nu = 1, $u = 2;
function Ru(e, t, n, r) {
  var o = n.length, i = o;
  if (e == null)
    return !i;
  for (e = Object(e); o--; ) {
    var u = n[o];
    if (u[2] ? u[1] !== e[u[0]] : !(u[0] in e))
      return !1;
  }
  for (; ++o < i; ) {
    u = n[o];
    var f = u[0], d = e[f], l = u[1];
    if (u[2]) {
      if (d === void 0 && !(f in e))
        return !1;
    } else {
      var _ = new C(), c;
      if (!(c === void 0 ? Fe(l, d, Nu | $u, r, _) : c))
        return !1;
    }
  }
  return !0;
}
function An(e) {
  return e === e && !ke(e);
}
function Wu(e) {
  for (var t = Ln(e), n = t.length; n--; ) {
    var r = t[n], o = e[r];
    t[n] = [r, o, An(o)];
  }
  return t;
}
function In(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
function Du(e) {
  var t = Wu(e);
  return t.length == 1 && t[0][2] ? In(t[0][0], t[0][1]) : function(n) {
    return n === e || Ru(n, e, t);
  };
}
var ju = "[object Symbol]";
function Ke(e) {
  return typeof e == "symbol" || F(e) && q(e) == ju;
}
var Bu = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Uu = /^\w*$/;
function Ve(e, t) {
  if (L(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || Ke(e) ? !0 : Uu.test(e) || !Bu.test(e) || t != null && e in Object(t);
}
var Hu = "Expected a function";
function qe(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(Hu);
  var n = function() {
    var r = arguments, o = t ? t.apply(this, r) : r[0], i = n.cache;
    if (i.has(o))
      return i.get(o);
    var u = e.apply(this, r);
    return n.cache = i.set(o, u) || i, u;
  };
  return n.cache = new (qe.Cache || P)(), n;
}
qe.Cache = P;
var zu = 500;
function ku(e) {
  var t = qe(e, function(r) {
    return n.size === zu && n.clear(), r;
  }), n = t.cache;
  return t;
}
var Gu = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Xu = /\\(\\)?/g, Fu = ku(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(Gu, function(n, r, o, i) {
    t.push(o ? i.replace(Xu, "$1") : r || n);
  }), t;
});
function Ku(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, o = Array(r); ++n < r; )
    o[n] = t(e[n], n, e);
  return o;
}
var At = R ? R.prototype : void 0, It = At ? At.toString : void 0;
function Pn(e) {
  if (typeof e == "string")
    return e;
  if (L(e))
    return Ku(e, Pn) + "";
  if (Ke(e))
    return It ? It.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function Vu(e) {
  return e == null ? "" : Pn(e);
}
function Ye(e, t) {
  return L(e) ? e : Ve(e, t) ? [e] : Fu(Vu(e));
}
function ae(e) {
  if (typeof e == "string" || Ke(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function Ze(e, t) {
  t = Ye(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[ae(t[n++])];
  return n && n == r ? e : void 0;
}
function qu(e, t, n) {
  var r = e == null ? void 0 : Ze(e, t);
  return r === void 0 ? n : r;
}
function Yu(e, t) {
  return e != null && t in Object(e);
}
function Zu(e, t, n) {
  t = Ye(t, e);
  for (var r = -1, o = t.length, i = !1; ++r < o; ) {
    var u = ae(t[r]);
    if (!(i = e != null && n(e, u)))
      break;
    e = e[u];
  }
  return i || ++r != o ? i : (o = e == null ? 0 : e.length, !!o && Xe(o) && Ge(u, o) && (L(e) || On(e)));
}
function Ju(e, t) {
  return e != null && Zu(e, t, Yu);
}
var Qu = 1, es = 2;
function ts(e, t) {
  return Ve(e) && An(t) ? In(ae(e), t) : function(n) {
    var r = qu(n, e);
    return r === void 0 && r === t ? Ju(n, e) : Fe(t, r, Qu | es);
  };
}
function ns(e) {
  return e;
}
function rs(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function os(e) {
  return function(t) {
    return Ze(t, e);
  };
}
function is(e) {
  return Ve(e) ? rs(ae(e)) : os(e);
}
function as(e) {
  return typeof e == "function" ? e : e == null ? ns : typeof e == "object" ? L(e) ? ts(e[0], e[1]) : Du(e) : is(e);
}
function us(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
function ss(e, t, n) {
  var r = -1, o = e.length;
  t < 0 && (t = -t > o ? 0 : o + t), n = n > o ? o : n, n < 0 && (n += o), o = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var i = Array(o); ++r < o; )
    i[r] = e[r + t];
  return i;
}
function cs(e, t) {
  return t.length < 2 ? e : Ze(e, ss(t, 0, -1));
}
function fs(e, t) {
  return t = Ye(t, e), e = cs(e, t), e == null || delete e[ae(us(t))];
}
var ls = Array.prototype, ds = ls.splice;
function ps(e, t) {
  for (var n = e ? t.length : 0, r = n - 1; n--; ) {
    var o = t[n];
    if (n == r || o !== i) {
      var i = o;
      Ge(o) ? ds.call(e, o, 1) : fs(e, o);
    }
  }
  return e;
}
function hs(e, t) {
  var n = [];
  if (!(e && e.length))
    return n;
  var r = -1, o = [], i = e.length;
  for (t = as(t); ++r < i; ) {
    var u = e[r];
    t(u, r, e) && (n.push(u), o.push(r));
  }
  return ps(e, o), n;
}
function Ys(e = 2e3) {
  const t = le([]);
  function n(o) {
    const i = Date.now();
    t.value.push({
      id: i,
      content: o
    }), setTimeout(() => r(i), e);
  }
  function r(o) {
    hs(t.value, (i) => o === i.id);
  }
  return { toasts: t, addToast: n, removeToast: r };
}
const Zs = "https://img.meinestadt.de/portal/common/ms_logo_500w.png";
export {
  $s as DateFormat,
  Rs as LinkMapper,
  Zs as MS_LOGO_IMAGE_URL,
  Cs as allContentByLabel,
  Rt as allContentsByMatcher,
  uo as assetLoader,
  Ns as clickAnywhereHandler,
  _e as cmsElementMapping,
  ws as commonUtils,
  Is as componentUtils,
  Wt as contentByLabel,
  De as contentByName,
  zs as dateUtils,
  Fs as enterLeaveDetector,
  Ps as extractDefaultHeadline,
  ce as extractLink,
  Ls as getCmsProperty,
  Po as getComponentByName,
  Io as getComponentByNameWithSafeguard,
  Gs as getComponentsWithSafeguard,
  Ms as hashCodeOf,
  Pr as inViewDetector,
  As as initConfig,
  Xs as isMounted,
  Ws as locationAutocomplete,
  rt as mediaQueryObserver,
  Ks as pageUtils,
  Ds as recaptcha,
  js as resizeObserver,
  xs as screenSizeDetection,
  rr as serverConfig,
  Cr as setDomainCookie,
  ks as setGlobalModules,
  et as sourcePoint,
  Bs as stringUtils,
  Us as structureUtils,
  Vs as urlUtils,
  qs as useDeploymentInfoStore,
  je as useGlobalStore,
  Ys as useToastManager,
  Hs as weatherUtils
};
